import React, { type PropsWithChildren } from 'react';
import { Inline, xcss, type InlineProps } from '@atlaskit/primitives';

const Subtext = ({
	children,
	alignBlock = 'center',
	space,
	alignInline,
}: PropsWithChildren<InlineProps>) => {
	return (
		<Inline xcss={subtextStyles} alignBlock={alignBlock} alignInline={alignInline} space={space}>
			{children}
		</Inline>
	);
};
const subtextStyles = xcss({
	gridArea: 'header-subtext',
});

export default Subtext;
